"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var constants_1 = require("./constants");
exports.setBreadcrumbs = function (breadcrumbs) { return ({
    type: constants_1.BREADCRUMBS,
    payload: { breadcrumbs: breadcrumbs },
}); };
/**
 * Publish a notification,
 */
function notificationSend(notif) {
    var payload = __assign({}, notif);
    return { type: constants_1.NOTIFICATION_SEND, payload: payload };
}
exports.notificationSend = notificationSend;
/**
 * Dismiss a notification by the given id.
 */
function notificationDismiss(id) {
    return { type: constants_1.NOTIFICATION_DISMISS, payload: id };
}
exports.notificationDismiss = notificationDismiss;
/**
 * Clear all notifications
 */
function notificationClear() {
    return { type: constants_1.NOTIFICATION_CLEAR };
}
exports.notificationClear = notificationClear;
//# sourceMappingURL=actions.js.map


//////////////////
// WEBPACK FOOTER
// .-core/es/utils/actions.js
// module id = 887
// module chunks = 0